import Device from './device'
import Shop from './shop'
import Video from './video'
import Banner from './banner'
import Agreement from './agreement'
import Order from './order'
import Recharge from './recharge'
import Type from './type'
import Wrap from '@/views/Wrap'
import Main from '@/views/dealer/Main'
import Login from '@/views/dealer/Login'
import dashboard from '@/views/dashboard'
import password from '@/views/dealer/password'

export default {
  path: '/dealer',
  name: 'platform',
  component: Wrap,
  redirect: 'dealer/main',
  meta: { hideInBreadcrumb: true },
  children: [
    {
      path: 'login/',
      name: 'login',
      component: Login
    },
    {
      path: 'main',
      name: 'home',
      component: Main,
      redirect: 'main/index',
      children: [
        {
          name: 'index',
          path: 'index',
          meta: { hideBreadcrumb: true },
          component: dashboard
        },
        {
          name: 'change_password',
          path: 'password',
          meta: { hideBreadcrumb: false },
          component: password
        },
        Device,
        Shop,
        Type,
        Order,
        Recharge,
        Video,
        Banner,
        Agreement
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/dealer/index.js